import { supabase } from './supabaseClient'
/**
 * Save the current step in the user's progress
 * @param step The identifier for the current step (e.g., "lesson-1", "module-2", etc.)
 * @returns Promise that resolves when the progress is saved
 */
export async function saveProgress(step: string) {
  const {
    data: { user },
    error: userError,
  } = await supabase.auth.getUser()
  if (userError || !user) {
    console.error('Not logged in:', userError)
    return
  }
  const { error } = await supabase.from('progress').upsert({
    user_id: user.id,
    current_step: step,
  })
  if (error) {
    console.error('Failed to save progress:', error.message)
  } else {
    console.log('Progress saved:', step)
  }
}
/**
 * Load the user's current progress step
 * @returns Promise that resolves to the current step or null if not found
 */
export async function loadProgress() {
  const {
    data: { user },
    error: userError,
  } = await supabase.auth.getUser()
  if (userError || !user) {
    console.error('Not logged in:', userError)
    return null
  }
  const { data, error } = await supabase
    .from('progress')
    .select('current_step')
    .eq('user_id', user.id)
    .single()
  if (error) {
    console.error('Failed to load progress:', error.message)
    return null
  }
  return data?.current_step
}
/**
 * Redirect to the appropriate page based on the user's progress
 * @param redirectCallback Function that handles the actual redirection
 */
export async function redirectToSavedProgress(
  redirectCallback: (step: string) => void,
) {
  const step = await loadProgress()
  if (step) {
    redirectCallback(step)
  }
}
